module.exports = __webpack_public_path__ + "static/ins-f5b0d34a9b7214b46ab90ae97a677322.jpg";